var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client"},[_c('router-view'),_c('div',{staticClass:"updiv"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-button',{staticClass:"hbt",on:{"click":_vm.left}})],1),_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}},[_c('el-button',{staticClass:"hbt",on:{"click":_vm.right}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }